/**
 * @enum {string} Profile image urls map. Key is the image version, value is the image url.
 */
export const PROFILE_IMAGE_VERSION = {
    PROFILE: 'PROFILE',
    PROFILE_FRIEND: 'PROFILE_FRIEND',
    PROFILE_THUMBNAIL: 'PROFILE_THUMBNAIL',
    FRAMED_PROFILE: atob('RlJBTUVEX1BST0ZJTEU='),
    FRAMED_FRIEND: atob('RlJBTUVEX0ZSSUVORA=='),
    FRAMED_THUMBNAIL: atob('RlJBTUVEX1RIVU1CTkFJTA=='),
    PREMIUM_PROFILE: atob('UFJFTUlVTV9QUk9GSUxF'),
    PREMIUM_FRIEND: atob('UFJFTUlVTV9GUklFTkQ='),
    PREMIUM_THUMBNAIL: atob('UFJFTUlVTV9USFVNQk5BSUw=')
};

export const imageVersionQueryString = Object.values(PROFILE_IMAGE_VERSION)
    .map((item) => `image-version=${item}`)
    .join('&');
